export const blockIconsAudioandvideoStopNew = (
	<span className='material-symbols-outlined'>stop</span>
);
